import React from 'react'
import { NumericFormat } from 'react-number-format';
import InfiniteScroll from "react-infinite-scroll-component";
import UsePagination from '../../../componentesAdmin/hooks/UsePagination';
import { useEffect } from 'react';
import { useState } from 'react';

function eliminarDiacriticos(texto) {
	return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

const ProductosPos = ({ funcion, baseUrl, productos, onClick, filtro, textoBuscador }) => {

	const [productosActuales, setproductosActuales] = useState([])

	useEffect(() => {
		const productosFiltro = []
		productos.map(producto => {
			const visualizacion = producto.visualizacion
			const validarVisualizacion = visualizacion.includes('Facturación');

			if (validarVisualizacion) {
				producto.categoria_producto.map(premise => {

					if (premise === filtro && textoBuscador.length > 0 && eliminarDiacriticos(producto.nombre_producto.toLowerCase()).indexOf(eliminarDiacriticos(textoBuscador)) !== -1 || premise === filtro && textoBuscador.length > 0 && eliminarDiacriticos(producto.id.toLowerCase()).indexOf(eliminarDiacriticos(textoBuscador)) !== -1 || premise === filtro && textoBuscador.length > 0 && eliminarDiacriticos(producto.referencia.toLowerCase()).indexOf(eliminarDiacriticos(textoBuscador)) !== -1) {
						return productosFiltro.push(producto)
					}

					if (textoBuscador.length == 0 && premise === filtro) {
						return productosFiltro.push(producto)
					}
				})
			}

		})
		setproductosActuales(productosFiltro)
	}, [productos, filtro, textoBuscador])




	const { items, terminado, handleSiguiente, itemsScroll } = UsePagination(productosActuales, 12)

	return (
		<>
			<div className=" animate__animated animate__rubberBand animate__slow contProductos d-none d-sm-none d-md-flex" id="scrollableDiv">
				{funcion === 'cargando' ?
					<div className="loader">Cargando...</div>
					: null}
				{funcion === 'ver' ?
					<InfiniteScroll
						dataLength={itemsScroll.length}
						next={handleSiguiente}
						hasMore={!terminado}
						scrollableTarget="scrollableDiv"
					>
						<ProductosItems itemsScroll={itemsScroll} baseUrl={baseUrl} onClick={onClick} />
					</InfiniteScroll>
					: null}
			</div >

			<div className=" animate__animated animate__rubberBand animate__slow contProductos d-flex d-sm-flex d-md-none" >
				{funcion === 'cargando' ?
					<div className="loader">Cargando...</div>
					: null}
				{funcion === 'ver' ?
					<InfiniteScroll
						dataLength={itemsScroll.length}
						next={handleSiguiente}
						hasMore={!terminado}
						height={400}
					>
						<ProductosItems itemsScroll={itemsScroll} baseUrl={baseUrl} onClick={onClick} />
					</InfiniteScroll>
					: null}
			</div >
		</>
	);
}

const ProductosItems = ({ itemsScroll, baseUrl, onClick }) => itemsScroll.map((producto, index) => {
	if (producto.activo === 'true') {

		if (producto.inventario == "true" && producto.inventarioCantidad == 0) {

			return (
				<React.Fragment key={index}>


					<div className="col-lg-3 col-md-4 col-6 CatProductos Agotado">

						<button
							name={producto.nombre_producto}
							className="btnProducto btn btn-block">
							Agotado
							<img src={baseUrl + 'productos/' + producto.imagePrev}
								className="img-responsive imageProducto" />
						</button>
						<h5 name={producto.nombre_producto}>{`${producto.nombre_producto}`}</h5>

						{producto.precio_rebajado > 0 ?
							<p>
								<span className="tachado">
									<NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
								</span><span> </span><NumericFormat value={producto.precio_rebajado} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
							: <p><NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
						}

					</div>

				</React.Fragment>
			)

		} else {
			return (
				<React.Fragment key={index}>


					<div className="col-lg-3 col-md-4 col-6 CatProductos">

						<button
							name={producto.nombre_producto}
							onClick={() => onClick(producto, index)}
							className="btnProducto btn btn-block">
							<img src={baseUrl + 'productos/' + producto.imagePrev} className="img-responsive imageProducto" />
						</button>
						<h5 name={producto.nombre_producto}>{`${producto.nombre_producto}`} {producto.inventario == "true" && producto.inventarioCantidad ? `x${producto.inventarioCantidad}` : ''}  </h5>
						{producto.precio_rebajado > 0 ?
							<p>
								<span className="tachado">
									<NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
								</span><span> </span><NumericFormat value={producto.precio_rebajado} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
							: <p><NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
						}

					</div>
				</React.Fragment>
			)

		}
	}
})


export default ProductosPos